<template>
  <div class="h-40 w-1/4">
    <div class="absolute w-1/4 mx-auto flex justify-center sm:ml-1.5 text-sm sm:text-2xl mt-[6.4rem] font-semibold importantText">{{ formatter.format(props.percentage/100) }}</div>
    <canvas class="absolute" ref="gaugeMeter"></canvas>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import Chart from "chart.js/auto";
import {useApiStore} from "@/stores/ApiStore";
const apiDataStore = useApiStore()

let props = defineProps({
  index: Number,
  label: String,
  data: Array,
  chartLabels: Array,
  colorPalette: Object,
  compareColor: String,
  percentage: String,
  update: Number
})

let gaugeMeter = ref(null);
let chart = ref(null);

onMounted (  () => {
  createGaugeChart()
})

function createGaugeChart(){
  chart.value = new Chart(gaugeMeter.value, fillData(props.chartLabels, props.label, props.data, getGaugeColor(props.colorPalette.primary), props.compareColor))

}

function getGaugeColor(color) {
  let valueString = color.substring(1)
  let c = addAlpha(valueString, props.percentage / 100)
  return "#" + c
}

function addAlpha(color, opacity) {
  // coerce values so it is between 0 and 1.
  let _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

function fillData(chartLabels, label, data,color, compareColor)
{
  return {
    type: "doughnut",
    data: {
      labels: chartLabels,
      datasets: [
        {
          data: data,
          backgroundColor: [color , compareColor ]
        },
      ]
    },
    options: {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      circumference: 180,
      rotation: -90,
      plugins: {
        legend: {
          display: false
        },
        title:{
          display: true,
          text: label,
          position: "bottom",
          align: "center",
          font: {
            size: 14
          }
        },
        tooltip: {
          titleFont: {
            weight: 'normal'
          },
          bodyFont: {
            weight: "bold"
          },
          displayColors: false,
          callbacks: {
            title: function (tooltipItem){
              return tooltipItem[0].label
            },
            label: function(tooltipItem) {
              return tooltipItem.formattedValue
            }
          }
        }
      }
    }
  }
}

watch( () => props.update, () => {
  chart.value.destroy()
  createGaugeChart();
})

let option = ref({
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
});
const formatter = new Intl.NumberFormat(apiDataStore.getLang, option.value);
</script>
